module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop"
  }, [_vm._v("Some of the ideas included in the reading of the Tarot in this story were gleaned from "), _c('i', [_vm._v("Tarot Made Easy")]), _vm._v(", Nancy Garen, A Fireside Book, Simon & Schuster, 1989.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 69
// module chunks = 0